export default "__VITE_ASSET__DVxD54Ns__"